module.exports = __webpack_public_path__ + "static/media/silex.ba366d63.png";